export const overviewKeepId = "{6CECFC83-5048-493C-987E-9397A9215222}";
export const stopKeepId = "{F9CF2205-F346-4836-AD4E-B952EBD3E0A0}";
export const oeeKeepId = "{196A9693-FE38-4BC4-BB0E-8423765680A8}";
export const qualityKeepId = "{365ABA10-A10C-4352-A99D-FBFCB581CEED}";
export const costKeepId = "{1D5DA3C3-BD6C-4548-A18C-019F9C691F00}";
export const scrapKeepId = "{493537DA-3E81-4EED-9CAB-34AB947F4E2E}";
export const parameterKeepId = "{A31EF429-C69B-4B2E-84AA-30E2911B5B84}";

export const StopReasons = [
  { value: 1, text: "跑条" },
  { value: 2, text: "甘油故障" },
  { value: 3, text: "断纸" },
  { value: 4, text: "清洁保养" },
  { value: 5, text: "质量问题" },
  { value: 6, text: "操作停机" }
];

export function getStopReasonText(value) {
  let obj = StopReasons.find(t => t.value == value) || {};
  return obj.text;
}

export const Consumables = {
  TrayPaper: { Type: 1, Unit: "盘",RuntimeUnit:"米" },
  TrayPaperRuntime: { Type: 11, Unit: "米" },
  ColdGlue: { Type: 2, Unit: "克" },
  HotGlue: { Type: 3, Unit: "克" },
  ClothTape: { Type: 4, Unit: "根",RuntimeUnit:"米" },
  Blade: { Type: 5, Unit: "片",RuntimeUnit:"次" },
  Bead: { Type: 6, Unit: "克" },
  Glycerin: { Type: 7, Unit: "克" },
  Spices: { Type: 8, Unit: "克" },
  Tow: { Type: 9, Unit: "千克" }
};

export function getConsumable(type) {
  let data = null;
  for (let key in Consumables) {
    let item = Consumables[key];
    if (item.Type == type) data = item;
  }

  return data;
}

export const Parameters = [
  { value: 1, text: "甘油" },
  { value: 2, text: "缝隙" },
  { value: 3, text: "丝绸" },
  { value: 4, text: "接头" },
  { value: 5, text: "破损" },
  { value: 6, text: "相位" },
  { value: 7, text: "多珠" },
  { value: 8, text: "少珠" },
  { value: 9, text: "色差" },
  { value: 10, text: "跳棒" },
  { value: 11, text: "珠直径" },
  { value: 12, text: "段数" },
  { value: 13, text: "同料" },
  { value: 14, text: "丝束的进量" },
  { value: 15, text: "速比(V1/V0)" },
];

export function getParameterText(value) {
  let obj = Parameters.find(t => t.value == value) || {};
  return obj.text;
}